<template>
  <section v-if="info.error" class="error">
    <div>
      <h1>{{ info.text }}</h1>
    </div>
  </section>
</template>

<script>

export default {
  name: 'NotFound',
  data() {
    return {
      info: ''
    }
  },
  beforeMount() {
    this.info = window.MY_CONFIG_EASYQ.info;
  }
}
</script>

<style>
.error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255,255,255,0.9);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 20px;
}
.error h1 {
  font-family: 'Roboto';
  font-size: 20px;
  font-weight: 600;
  color: #263128;
  text-align: center;
}
</style>